import React, { PureComponent } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import LinearGradient from 'react-native-linear-gradient';
import colors from '../../../theme/Colors';
import size from '../../../theme/Fonts';
import CircularProgress from './CircularProgress';
import { getScreenWidth } from '../../../utils/LayoutUtility';
import { isBlank } from '../../../utils/BooleanUtility';

class RoutineTotalProgressCard extends PureComponent {
  render() {
    const {
      itemData: {
        progress = 60,
        title = '',
        extraArguments: { completedMessage = '' },
      },
    } = this.props;
    const progressCardMessage = isBlank(completedMessage)
      ? `You only completed ${progress}% of the campaign. But hey, a start is a start! Remember, consistency is key to forming a habit!`
      : completedMessage;
    return (
      <LinearGradient
        colors={[colors.peach, colors.light_peach]}
        style={styles.fullWidthCardContainer}
        start={{ x: 0, y: 0 }}
        end={{ x: 0, y: 1 }}
      >
        <CircularProgress size={100} strokeWidth={8} progress={progress} />
        <Text style={styles.text}>{progressCardMessage}</Text>
      </LinearGradient>
    );
  }
}

export default RoutineTotalProgressCard;

const styles = StyleSheet.create({
  container: {
    borderRadius: 16,
    flexDirection: 'row',
    overflow: 'visible',
    alignItems: 'center',
    width: getScreenWidth() - 30,
  },
  fullWidthCardContainer: {
    borderRadius: 16,
    flexDirection: 'row',
    overflow: 'visible',
    alignItems: 'center',
    alignSelf: 'center',
    width: getScreenWidth() - 30,
  },
  text: {
    color: colors.black,
    fontFamily: 'Roboto-Regular',
    fontSize: size.h3,
    marginLeft: 20,
    flexWrap: 'wrap',
    flex: 1,
    paddingRight: 6,
  },
});
